import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuthApi } from "../../hooks/useAuthApi";
import styles from "./Login.module.css";
import { Button, TextField, InputAdornment, IconButton } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

export default function LoginForm() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const { login, loading, error, clearError } = useAuthApi();

  const handleSubmit = async (e) => {
    e.preventDefault();
    clearError();

    await login({ email, password });
  };

  return (
    <form className={styles.loginForm} onSubmit={handleSubmit}>
      <h2>Sign In</h2>
      {error && <p className={styles.error} style={{ whiteSpace: 'pre-line' }}>{error}</p>}
      <TextField
        id="login-email"
        type="email"
        label={"Email"}
        name="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        autoFocus
        disabled={loading}
        inputProps={{ maxLength: 255 }}
        sx={{
          width: "100%",
          maxWidth: 260,
          marginBottom: 1,
          "& .MuiInputBase-input": {
            fontSize: 14,
            height: 44,
            boxSizing: "border-box",
            padding: "10px 14px",
          },
          "& input:-webkit-autofill": {
            fontSize: 14,
            height: 44,
            boxSizing: "border-box",
            padding: "10px 14px",
            WebkitBoxShadow: "0 0 0 100px #fff inset",
            WebkitTextFillColor: "#000",
          },
        }}
      />

      <TextField
        id="login-password"
        type={showPassword ? "text" : "password"}
        label={"Password"}
        name="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
        disabled={loading}
        inputProps={{ maxLength: 64 }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={() => setShowPassword(!showPassword)}
                edge="end"
              >
                {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </IconButton>
            </InputAdornment>
          ),
        }}
        sx={{
          width: "100%",
          maxWidth: 260,
          marginBottom: 1,
          "& .MuiInputBase-input": {
            fontSize: 14,
            height: 44,
            boxSizing: "border-box",
            padding: "10px 14px",
          },
          "& input:-webkit-autofill": {
            fontSize: 14,
            height: 44,
            boxSizing: "border-box",
            padding: "10px 14px",
            WebkitBoxShadow: "0 0 0 100px #fff inset",
            WebkitTextFillColor: "#000",
          },
        }}
      />
      <Button
        variant="contained"
        type="submit"
        disabled={loading}
        sx={{
          marginTop: 2,
          fontSize: 13,
          height: 44,
          backgroundColor: "#AB2C29",
          "&:hover": { backgroundColor: "#b71c1c" },
        }}
      >
        {loading ? "Signing In..." : "Continue"}
      </Button>

      <div className={styles.loginForgot}>
        <Link to="/forgot-password">Forgot Password?</Link>
      </div>
    </form>
  );
}
